// extracted by mini-css-extract-plugin
export var addressFields = "_o8-0";
export var animationContainer = "_o8-1";
export var footer = "_o8-2";
export var lineItems = "_o8-3";
export var modalContent = "_o8-4";
export var orderName = "_o8-5";
export var strong = "_o8-6";
export var warning = "_o8-7";